export default __webpack_public_path__ + "static/media/waiver-type.045f641e.svg";